module.exports = __webpack_public_path__ + "static/img/ban1.13d1c7a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/ban1.jpg
// module id = mus/
// module chunks = 55